import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { makeRequest2 } from '../../../../../../utils/makeRequest';
import { smart_meters_base_url } from '../../../../../../utils/urls';
import { toastify } from '../../../../../../utils/toast';

const MonthlyMeterReadingHistory = ({ meterId }) => {
    const [allReadings, setAllReadings] = useState([]);
    const [readings, setReadings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [date, setDate] = useState(''); // YYYY-MM

    useEffect(() => {
        fetchMonthlyReadings();
    }, [meterId]);

    const fetchMonthlyReadings = async () => {
        if (!meterId) return;

        setLoading(true);
        try {
            const url = `${smart_meters_base_url}/monthly_readings/${meterId}`;
            const response = await makeRequest2(url, 'GET');

            if (response.success) {
                const historyData = response.data.history || [];
                setAllReadings(historyData);
                setReadings(historyData); // Show all by default
            } else {
                toastify('Failed to fetch monthly readings', 'error');
                setAllReadings([]);
                setReadings([]);
            }
        } catch (err) {
            toastify('Error fetching monthly readings', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleFilter = () => {
        if (!date) {
            setReadings(allReadings);
            return;
        }

        const filtered = allReadings.filter(reading => {
            return reading.yearMonth === date; // e.g., "2024-09"
        });

        setReadings(filtered);
    };

    // Custom body templates for columns that need 2 decimal places
    const initialReadingTemplate = (rowData) => {
        return rowData.initialReading !== null && rowData.initialReading !== undefined
            ? Number(rowData.initialReading).toFixed(2)
            : '';
    };

    const finalReadingTemplate = (rowData) => {
        return rowData.finalReading !== null && rowData.finalReading !== undefined
            ? Number(rowData.finalReading).toFixed(2)
            : '';
    };

    const consumptionTemplate = (rowData) => {
        return rowData.consumption !== null && rowData.consumption !== undefined
            ? Number(rowData.consumption).toFixed(2)
            : '';
    };

    return (
        <div className="row">
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-header">
                        <div className="row">
                            <div className="col-md-4">
                                <label>Year Month</label>
                                <input
                                    type="month"
                                    className="form-control"
                                    value={date}
                                    onChange={(e) => setDate(e.target.value)}
                                />
                            </div>
                            <div className="col-md-4 d-flex align-items-end">
                                <Button
                                    label="Filter"
                                    onClick={handleFilter}
                                    className="btn btn-primary btn-sm"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <DataTable
                            value={readings}
                            loading={loading}
                            paginator
                            rows={10}
                            stripedRows
                        >
                            <Column 
                                field="initialReading" 
                                header="Initial Reading (m³)" 
                                sortable
                                body={initialReadingTemplate} 
                            />
                            <Column 
                                field="finalReading" 
                                header="Final Reading (m³)" 
                                sortable 
                                body={finalReadingTemplate}
                            />
                            <Column 
                                field="consumption" 
                                header="Consumption (m³)" 
                                sortable 
                                body={consumptionTemplate}
                            />
                            <Column field="yearMonth" header="Year Month" sortable />
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MonthlyMeterReadingHistory;